export const EXECUTED_TASK_STATUSES = [
	'RUNNING',
	'FAILED',
	'COMPLETED',
	'OVERRIDEN',
	'READY',
	'IN_PROGRESS',
	'SCHEDULED',
	'RE_RUN',
	'SCHEDULED_FOR_DEPLOYMENT',
    'PENDING_APPROVAL',
    'PENDING_REVIEW'
] as const;

export const WAITING_TASK_STATUSES = ['WAITING'] as const;

export const SIM_TASK_TYPES = ['SIMTask', 'TTTask', 'CreateSimTask'] as const;

export const STATUS_TAB_MAP: { [key: string]: string } = {
	WAITING: 'Waiting',
	TOTAL: 'executedTasks',
	COMPLETED: 'executedTasks',
	RUNNING: 'executedTasks',
	OVERRIDEN: 'executedTasks',
	FAILED: 'executedTasks',
	RE_RUN: 'executedTasks',
};

interface TaskExecution {
	taskType: string;
	status: string;
	[key: string]: unknown;
}

export const filterSIMTasks = (items: TaskExecution[]): TaskExecution[] => {
	return items.filter((item) => SIM_TASK_TYPES.includes(item.taskType as any));
};

export const createStatusClickHandler = (
	setCurrentTab: (tab: string) => void,
	setStatusFilter: (filter: string | null) => void,
	statusFilter: string | null
) => {
	return (status: string) => {
		const newTab = STATUS_TAB_MAP[status] || 'executedTasks';

		if (status === 'TOTAL') {
			setCurrentTab(newTab);
			setStatusFilter(null);
		} else if (statusFilter === status) {
			setCurrentTab(newTab);
			setStatusFilter(null);
		} else {
			setCurrentTab(newTab);
			setStatusFilter(status);
		}
	};
};
